const _ = require('lodash')

const statuses = [
    {text: "", value: ""},
    {text: "Prenotata", value: "booked"},
    {text: "Completata", value: "completed"},
    {text: "Da pagare", value: "to_be_payed"},
    {text: "Cancellata", value: "canceled"},
    {text: "Rimborsata", value: "refunded"},
    {text: "Interrotta", value: "interrupted"},
    {text: "In Attesa", value: "pending"},
    {text: "Da Confermare", value: "to_be_confirmed"},
    {text: "Attivo", value: true},
    {text: "Disattivato", value: false},
]

export async function getCsv(headers, items) {
    return new Promise(async (resolve, reject) => {
        try {

            let csv = "data:text/csv;charset=utf-8,";

            for(let row = -1; row < items.length; row++){
                let keysAmount = headers.length
                let keysCounter = 0

                if(row === -1){

                    for(let header of headers){
                        csv += header.text + (keysCounter+1 < keysAmount ? ';' : '\r\n' )
                        keysCounter++
                    }

                }else{

                    for(let header of headers){

                        var value = ''

                        switch (header.value) {
                            case 'customer':
                                if(items[row]['customer'][0]){
                                    value = items[row]['customer'][0].name + ' ' + items[row]['customer'][0].surname
                                }else if(items[row]['note']){
                                    value = items[row]['note']
                                }else {
                                    value = 'N.D.'
                                }
                                break
                            case 'center':
                                if(items[row]['center'][0]){
                                    value = items[row]['center'][0].name
                                }else {
                                    value = 'N.D.'
                                }
                                break
                            case 'center.name':
                                value = (items[row]['center']) ? items[row]['center'].name : 'N.D.'
                                break
                            case 'booking':
                                if(items[row]['booking'][0]){
                                    value = items[row]['booking'][0].code
                                }else {
                                    value = 'N.D.'
                                }
                                break
                            case 'field':
                                if(items[row]['field'][0]){
                                    value = items[row]['field'][0].name
                                }else {
                                    value = 'N.D.'
                                }
                                break
                            case 'sport':
                                if(items[row]['sport'][0]){
                                    value = items[row]['sport'][0].name
                                }else {
                                    value = 'N.D.'
                                }
                                break
                            case 'sports_info':
                                if(items[row]['sports_info']){
                                    for(let sport of items[row]['sports_info']){
                                        value += sport.name+','
                                    }
                                }else {
                                    value = 'N.D.'
                                }
                                break
                            case 'status':
                                var find = _.find(statuses, {'value':items[row]['status']})
                                value = (find) ? find.text : items[row]['status']
                                if(!value){
                                    value = (items[row]['active']) ? 'Attivo' : 'Non attivo'
                                }
                                break
                            case 'refund.type':
                                var type = items[row]['refund'].type
                                if(type == 'nothing'){
                                    value = 'Nessuno'
                                }else if( type == 'fixed'){
                                    value ='Importo Fisso'
                                }else if( type == 'promo_code'){
                                    value = 'Promo Code'
                                }
                                break
                            case 'refund.value':
                                var value = items[row]['refund'].value
                                break
                            case 'date':
                                var slot = getSlot(items[row]['date'],items[row]['slot_id'])
                                value = slot
                                break
                            case 'promo_sa':
                                value = (items[row]['promo_sa']) ? 'SI':'NO'
                                break
                            case 'promo_sa_global':
                                value = (items[row]['promo_sa_global']) ? 'SI':'NO'
                                break
                            case 'created_at':
                                value = new Date(items[row]['created_at']).toLocaleString()
                                break
                            case 'updated_at':
                                value = new Date(items[row]['updated_at']).toLocaleString()
                                break
                            case 'action':
                            case 'actions':
                                value = ''
                                break
                            default:
                                value = items[row][header.value]
                                break
                        }

                        csv += value + (keysCounter+1 < keysAmount ? ';' : '\r\n' )
                        keysCounter++
                    }

                    // for(let line of items[row]){
                    //     if(typeof items[row][key] === 'object' ){
                    //         csv += JSON.stringify(items[row][key]) + (keysCounter+1 < keysAmount ? ';' : '\r\n' )
                    //     }else {
                    //         csv += items[row][key] + (keysCounter+1 < keysAmount ? ';' : '\r\n' )
                    //     }
                    //     keysCounter++
                    // }
                }

                keysCounter = 0
            }

            resolve(csv)

        } catch (error) {
            console.log(error.stack);
            console.log(error.message);
            resolve(false)
        }

    });
}


function getSlot(date, slot_id) {
    if(!slot_id) return ''
    let split = slot_id.split(';')
    return `${split[0]}/${split[1]}/${split[2]} | ${split[3]} - ${split[4]}`
}
